import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  examId: null,
  error: "",
  status: "idle",
  question: null,
  lastQuestion: false,
  submitId: "",
};

export const startDynamicExam = createAsyncThunk(
  "dynamicExam/startDynamicExam",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/dynamicexam/create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const getDynamicQuestion = createAsyncThunk(
  "dynamicExam/getDynamicQuestion",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/dynamicexam/question/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const submitQuestion = createAsyncThunk(
  "dynamicExam/submitQuestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/dynamicexam/submit", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

const dynamicExamSlice = createSlice({
  name: "dynamicExam",
  initialState,
  reducers: {
    resetDynamicExam: (state) => {
      state.error = "";
      state.examId = null;
      state.question = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Start a Exam
      .addCase(startDynamicExam.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(startDynamicExam.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.examId = action.payload.examId;
      })
      .addCase(startDynamicExam.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })

      //   Submit a question of a exam
      .addCase(submitQuestion.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(submitQuestion.fulfilled, (state, action) => {
        state.error = "";
        state.status = "success";
      })
      .addCase(submitQuestion.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
        state.submitId = action.payload.submitId;
      })
      .addCase(getDynamicQuestion.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getDynamicQuestion.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.question = action.payload.data;
        state.lastQuestion = action.payload.lastQuestion;
      })
      .addCase(getDynamicQuestion.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
  },
});

export const { resetDynamicExam } = dynamicExamSlice.actions;

export const getDynamicExamQuestion = (state) => state.dynamicExam.question;
export const getDynamicExamId = (state) => state.dynamicExam.examId;
export const getDynamicExamStatus = (state) => state.dynamicExam.status;
export const getDynamicExamError = (state) => state.dynamicExam.error;

export const getDynamicSubmitId = (state) => state.dynamicExam.submitId;
export const getIsLastQuestion = (state) => state.dynamicExam.lastQuestion;

export default dynamicExamSlice.reducer;
